<template>
  <div class="p-max-wrap">
    <div class="p-max-1500">
      <!-- Newsletter -->
      <div class="footer-newsletter" id="newsletter">
        <div class="footer-newsletter-title">
          <span class="title-sub ff-20">{{$t('footLetter.text1')}}</span>
          <span class="title-1 ff-20">
            {{$t('footLetter.text2')}}
          </span>
        </div>
        <div class="footer-newsletter-right">
          <div class="footer-newsletter-form-container" style="width: 80%;">
            <!-- action="/newsletter/subscribe" -->
            <!-- method="post" -->
            <form class="footer-newsletter-form"
              novalidate>
              <div class="footer-newsletter-right-mail input input-icon">
                <svg class="icon icon-mail">
                  <use xlink:href="#mail"></use>
                </svg>
                <input type="email"
                  required
                  name="email"
                  placeholder="email address"
                  @focus="open = true">
              </div>
              <div class="footer-newsletter-more" :class="{ open }">
                <div class="footer-newsletter-more-inner">
                  <div class="footer-newsletter-right-name input input-icon">
                    <svg class="icon icon-etiquette">
                      <use xlink:href="#etiquette"></use>
                    </svg>
                    <input required type="text" name="firstname" placeholder="subject">
                  </div>
                </div>

                <div class="footer-newsletter-more-inner">
                  <div class="footer-newsletter-right-subname input input-icon">
                    <svg class="icon icon-etiquette">
                      <use xlink:href="#etiquette"></use>
                    </svg>
                    <input required type="text" name="lastname" placeholder="content">
                  </div>
                </div>
                <div class="close-btn ft-16"
                  @click="open = false">
                  <div>CANCEL</div>
                </div>
              </div>
              <div class="footer-newsletter-bt-container hover-bg-blue">
                <!-- type="submit"  -->
                <div class="footer-newsletter-bt ft-16">SEND</div>
              </div>
            </form>
          </div>
          <div class="footer-newsletter-error">
            <div
              class="footer-newsletter-error-item footer-newsletter-error-empty"
            >Tous les champs sont obligatoires.</div>
            <div class="footer-newsletter-error-item footer-newsletter-error-email">
              Le format de l'adresse email n'est
              pas valide.
            </div>
            <div class="footer-newsletter-confirm hidden">
              <svg class="icon icon-check">
                <use xlink:href="#check"></use>
              </svg> Votre inscription à la newsletter a bien été enregistrée.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      open: false
    }
  }
}
</script>

<style lang="scss" scoped>
.title-sub {
  display: block;
  text-align: center;
  letter-spacing: .4em;
  line-height: 30px;
}

.title-1 {
  display: block;
  text-align: center;
  letter-spacing: .4em;
  line-height: 30px;
}

.input,.textarea {
  -webkit-transition: border .5s cubic-bezier(.165,.84,.44,1);
  transition: border .5s cubic-bezier(.165,.84,.44,1);
  border: 1px solid #eaeaea
}

.input.focus,.textarea.focus {
  border: 1px solid #96daf0
}

.input.error,.textarea.error {
  border: 1px solid #b23439
}

.input input,.input textarea,.textarea input,.textarea textarea {
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  color: #242a3a;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%
}

.input input::-webkit-input-placeholder,.input textarea::-webkit-input-placeholder,.textarea input::-webkit-input-placeholder,.textarea textarea::-webkit-input-placeholder {
  color: #d8d8d8
}

.input input::-moz-placeholder,.input textarea::-moz-placeholder,.textarea input::-moz-placeholder,.textarea textarea::-moz-placeholder {
  color: #d8d8d8
}

.input input:-ms-input-placeholder,.input textarea:-ms-input-placeholder,.textarea input:-ms-input-placeholder,.textarea textarea:-ms-input-placeholder {
  color: #d8d8d8
}

.input input:-moz-placeholder,.input textarea:-moz-placeholder,.textarea input:-moz-placeholder,.textarea textarea:-moz-placeholder {
  color: #d8d8d8
}

.input input::-webkit-inner-spin-button,.input input::-webkit-outer-spin-button,.input textarea::-webkit-inner-spin-button,.input textarea::-webkit-outer-spin-button,.textarea input::-webkit-inner-spin-button,.textarea input::-webkit-outer-spin-button,.textarea textarea::-webkit-inner-spin-button,.textarea textarea::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0
}

.input textarea,.textarea textarea {
  resize: none;
  height: 205px;
  padding-top: 15px;
  padding-bottom: 15px;
  line-height: 1em
}

.input .input-after,.textarea .input-after {
  font-size: 14px;
  color: #242a3a;
  position: absolute;
  right: 15px;
  top: 0;
  height: 100%;
  line-height: 45px;
  display: block
}

.textarea {
  line-height: 0
}

.input-icon {
  position: relative
}

.input-icon input {
  height: 50px;
  line-height: 50px
}

.input-icon.error .icon {
  fill: #b23439!important
}

.input-icon.active .icon {
  fill: #242a3a
}

.input-icon:before {
  content: "";
  display: block;
  width: 50px;
  height: 50px;
  background-color: #fff;
  z-index: 1001;
  border-right: 1px solid #eaeaea;
  position: absolute;
  left: 0;
  top: 0
}

.input-icon .icon {
  width: 20px;
  height: 20px;
  position: relative;
  z-index: 1010;
  position: absolute;
  left: 15px;
  top: 15px;
  fill: #eaeaea;
  -webkit-transition: fill .8s cubic-bezier(.165,.84,.44,1);
  transition: fill .8s cubic-bezier(.165,.84,.44,1)
}

.input-icon input {
  display: inline-block;
  padding-left: 65px
}

.input-bt {
  position: relative
}

.input-bt .btn {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1100;
  width: 47px;
  height: 45px
}

.input-bt .btn:hover .icon {
  fill: #96daf0
}

.input-bt .btn:before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  height: 25px;
  width: 1px;
  top: 50%;
  margin-top: -12px;
  z-index: 1100;
  background-color: #eaeaea
}

.input-bt .btn input {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1100;
}

.input-bt .btn .icon {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -10px;
  margin-left: -10px;
  width: 18px;
  height: 18px;
  fill: #242a3a;
  z-index: 1050;
  -webkit-transition: fill .5s cubic-bezier(.165,.84,.44,1);
  transition: fill .5s cubic-bezier(.165,.84,.44,1)
}

.footer-newsletter {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-top: 1px solid #eaeaea;
  padding-top: 75px;
  margin-bottom: 60px;
  position: relative;
  z-index: 1100;
}

.footer-newsletter-title {
  // text-align: left;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

// .footer-newsletter-title .title-sub {
//   margin-bottom: 0
// }

// .footer-newsletter-title .title-1,.footer-newsletter-title .title-sub {
//   text-align: left
// }

.footer-newsletter-right {
  flex: 1;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-newsletter-form-container {
  display: block;
  padding: 15px;
  padding-right: 175px;
  background-color: #eaeaea;
  position: relative
}

.footer-newsletter-names {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 23px
}

.footer-newsletter-names .input:first-child {
  margin-right: 10px
}

.footer-newsletter-names .input {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1
}

.footer-newsletter-bt {
  cursor: pointer;
  // text-align: center;
  position: absolute;
  background-color: transparent!important;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1020;
  color: #fff!important;

  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-newsletter-bt-container {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  width: 160px;
  background-color: #242a3a
}

.footer-newsletter-more {
  height: 0;
  overflow: hidden
}

.footer-newsletter-more-inner {
  opacity: 0;
  padding-top: 15px;
  padding-bottom: 1px;
  -webkit-transition: opacity .8s cubic-bezier(.165,.84,.44,1);
  transition: opacity .8s cubic-bezier(.165,.84,.44,1)
}

.footer-newsletter-more.open {
  height: 180px;
}
.footer-newsletter-more.open .footer-newsletter-more-inner {
  opacity: 1
}

.close-btn {
  cursor: pointer;
  margin-top: 8px;
  width: 100px;
  height: 36px;
  color: #999;
  display: flex;
  align-items: center;
}

.footer-newsletter-error {
  position: relative;
  margin-top: 5px;
  height: 12px;
  font-size: 12px;
  color: #b23439
}

.footer-newsletter-error-item {
  position: absolute;
  top: 0;
  width: 100%;
  opacity: 0;
  -webkit-transition: opacity .8s cubic-bezier(.165,.84,.44,1);
  transition: opacity .8s cubic-bezier(.165,.84,.44,1)
}

.footer-newsletter-error-item.show {
  opacity: 1
}

.footer-newsletter-confirm {
  font-size: 12px;
  color: #242a3a;
  margin-top: 10px;
  position: relative
}

.footer-newsletter-confirm:before {
  content: "";
  display: block;
  position: absolute;
  border-radius: 100%;
  border: 2px solid #242a3a;
  opacity: .1;
  width: 16px;
  height: 16px;
  top: -1px
}

.footer-newsletter-confirm .icon {
  fill: #242a3a;
  width: 6px;
  height: 6px;
  display: inline-block;
  margin-right: 15px;
  margin-left: 7px
}

.footer-newsletter-confirm.hidden {
  display: none
}

.footer-bottom-logos {
    position: absolute;
    right: 40px;
    top: 50%;
    margin-top: -10px
}

.footer-bottom-logos-item {
    display: inline-block;
    margin-left: 10px
}

.footer-bottom-logos .icon {
    fill: #fff;
    width: 20px;
    height: 20px
}

@media (max-width: 1240px) {
    .footer .wrapper-1120 {
        padding-left:40px;
        padding-right: 40px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 100%
    }

    .footer-partners-item {
        position: relative;
        vertical-align: middle
    }

    .footer-partners-item img {
        max-width: 80%
    }

    .footer-infos-address {
        padding-left: 14px
    }

    .footer-infos-logo {
        width: 105px
    }

    .footer-map-col:first-child {
        margin-right: 40px;
        width: calc((100% / 3) - 40px)
    }

    .footer-map-col:last-child {
        margin-left: 40px;
        width: calc((100% / 3) - 40px)
    }
}

@media (max-width: 1020px) {
    .footer-ref-col:first-child {
        margin-right:40px
    }

    .footer-ref-col:last-child {
        margin-left: 40px
    }
}

@media (max-width: 960px) {
    .footer {
        padding-top:100px
    }

    .footer-top-title {
        font-size: 160px;
        line-height: 160px
    }

    .footer-top-sub {
        font-size: 20px
    }

    .footer-top {
        margin-bottom: 260px
    }

    .footer-newsletter,.footer-ref {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column
    }

    .footer-map-col,.footer-ref-col {
        width: 100%!important;
        margin: 0;
        margin-bottom: 40px;
        display: block
    }

    .footer-map-col:first-child,.footer-map-col:last-child,.footer-ref-col:first-child,.footer-ref-col:last-child {
        margin-left: 0;
        margin-right: 0
    }

    .footer-newsletter-title {
        width: 100%
    }

    .footer-newsletter-right {
        width: 100%;
        margin-top: 30px
    }

    .footer-newsletter-form-container {
        width: 100%;
        padding-right: 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

    .footer-newsletter-bt-container {
        display: block;
        position: relative;
        width: 100%;
        height: 60px;
        margin-top: 10px
    }

    .footer-infos {
        width: 100%;
        max-width: 300px
    }

    .footer-partners {
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start
    }

    .footer-partners-item {
        width: 50%;
        margin-bottom: 20px
    }

    .footer-bottom {
        padding-right: 80px;
        padding-left: 80px
    }

    .footer-bottom-logos {
        right: 30px
    }

    .footer-bottom-logos-item {
        margin-left: 4px
    }
}

@media (max-width: 760px) {
    .footer-top-title {
        font-size:120px;
        line-height: 120px
    }

    .footer-top-sub {
        font-size: 15px
    }

    .footer-top {
        margin-bottom: 200px
    }

    .footer-ref {
        margin-bottom: 20px
    }

    .footer-partners {
        display: block
    }

    .footer-partners-items {
        margin-top: 30px
    }

    .footer-partners-item {
        width: calc(100% / 4)
    }

    .footer-partners-title {
        width: auto
    }

    .footer-newsletter {
        padding-top: 35px;
        border: 0
    }

    .footer-newsletter-right {
        max-width: 100%;
        width: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

    .footer-newsletter-form-container {
        padding: 15px
    }

    .footer-bottom {
        height: auto;
        padding-bottom: 20px;
        padding-top: 20px
    }

    .footer-bottom-link {
        line-height: 40px
    }

    .footer-partners {
        margin-bottom: 30px
    }

    .footer-map {
        padding-top: 55px
    }

    .footer-map {
        margin-bottom: 0
    }

    .footer-infos-socials-item {
        margin-right: 5px
    }

    .footer-bottom {
        padding-right: 20px;
        padding-left: 20px
    }

    .footer-bottom-logos {
        display: block;
        margin: 10px auto;
        position: relative;
        right: auto
    }

    .footer-bottom-logos-item {
        margin: 0 6px
    }
}

@media (max-width: 520px) {
    .footer .wrapper-1120 {
        padding-left:30px;
        padding-right: 30px
    }

    .footer-top-title {
        font-size: 70px;
        line-height: 70px;
        top: 20px
    }

    .footer-top-sub {
        font-size: 9px;
        top: 20px
    }

    .footer-top {
        margin-bottom: 140px
    }

    .footer-partners-item {
        width: 50%
    }

    .footer-infos {
        margin-left: 0;
        position: relative;
        left: -50px;
        width: 100%;
        width: calc(100% + 50px)
    }

    .footer-infos-socials {
        padding: 0
    }

    .footer-infos-address {
        padding-left: 10px
    }

    .footer-infos-follow {
        width: 100px
    }

    .footer-infos-socials-item {
        padding-left: 4px;
        padding-right: 4px
    }

    .footer-infos-follow {
        width: 90px
    }

    .footer-newsletter-names {
        display: block;
        margin-bottom: 0
    }

    .footer-newsletter-names .input {
        margin: 0!important;
        margin-bottom: 15px!important
    }
}

.hidden-form {
    display: none
}

.input,.textarea {
    -webkit-transition: border .5s cubic-bezier(.165,.84,.44,1);
    transition: border .5s cubic-bezier(.165,.84,.44,1);
    border: 1px solid #eaeaea
}

.input.focus,.textarea.focus {
    border: 1px solid #96daf0
}

.input.error,.textarea.error {
    border: 1px solid #b23439
}

.input input,.input textarea,.textarea input,.textarea textarea {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #242a3a;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%
}

.input input::-webkit-input-placeholder,.input textarea::-webkit-input-placeholder,.textarea input::-webkit-input-placeholder,.textarea textarea::-webkit-input-placeholder {
    color: #d8d8d8
}

.input input::-moz-placeholder,.input textarea::-moz-placeholder,.textarea input::-moz-placeholder,.textarea textarea::-moz-placeholder {
    color: #d8d8d8
}

.input input:-ms-input-placeholder,.input textarea:-ms-input-placeholder,.textarea input:-ms-input-placeholder,.textarea textarea:-ms-input-placeholder {
    color: #d8d8d8
}

.input input:-moz-placeholder,.input textarea:-moz-placeholder,.textarea input:-moz-placeholder,.textarea textarea:-moz-placeholder {
    color: #d8d8d8
}

.input input::-webkit-inner-spin-button,.input input::-webkit-outer-spin-button,.input textarea::-webkit-inner-spin-button,.input textarea::-webkit-outer-spin-button,.textarea input::-webkit-inner-spin-button,.textarea input::-webkit-outer-spin-button,.textarea textarea::-webkit-inner-spin-button,.textarea textarea::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0
}

.input textarea,.textarea textarea {
    resize: none;
    height: 205px;
    padding-top: 15px;
    padding-bottom: 15px;
    line-height: 1em
}

.input .input-after,.textarea .input-after {
    font-size: 14px;
    color: #242a3a;
    position: absolute;
    right: 15px;
    top: 0;
    height: 100%;
    line-height: 45px;
    display: block
}

.textarea {
    line-height: 0
}

.input-icon {
    position: relative
}

.input-icon input {
    height: 50px;
    line-height: 50px
}

.input-icon.error .icon {
    fill: #b23439!important
}

.input-icon.active .icon {
    fill: #242a3a
}

.input-icon:before {
    content: "";
    display: block;
    width: 50px;
    height: 50px;
    background-color: #fff;
    z-index: 0;
    border-right: 1px solid #eaeaea;
    position: absolute;
    left: 0;
    top: 0
}

.input-icon .icon {
    width: 20px;
    height: 20px;
    position: relative;
    z-index: 1;
    position: absolute;
    left: 15px;
    top: 15px;
    fill: #eaeaea;
    -webkit-transition: fill .8s cubic-bezier(.165,.84,.44,1);
    transition: fill .8s cubic-bezier(.165,.84,.44,1)
}

.input-icon input {
    display: inline-block;
    padding-left: 65px
}

.input-bt {
    position: relative
}

.input-bt .btn {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    width: 47px;
    height: 45px
}

.input-bt .btn:hover .icon {
    fill: #96daf0
}

.input-bt .btn:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    height: 25px;
    width: 1px;
    top: 50%;
    margin-top: -12px;
    z-index: 10;
    background-color: #eaeaea
}

.input-bt .btn input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 10
}

.input-bt .btn .icon {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -10px;
    margin-left: -10px;
    width: 18px;
    height: 18px;
    fill: #242a3a;
    z-index: 5;
    -webkit-transition: fill .5s cubic-bezier(.165,.84,.44,1);
    transition: fill .5s cubic-bezier(.165,.84,.44,1)
}

input {
  background-color: #fff;
}
@media(max-width: 768px){
  #newsletter{
    display: none;
  }
}
</style>
